import * as Stores from '../stores'

export function useReferralBonusOfferEligibility() {
  const referralBonusOfferEligibility = Stores.CardBenefitsApi.endpoints[
    'GET /benefits/referral-bonus/eligibility'
  ].useQuery(
    {},
    {
      selectFromResult({ data, isLoading, isUninitialized, isSuccess, error }) {
        return {
          isUninitialized,
          isLoading,
          isSuccess,
          error,
          data: data?.isEligible ?? null,
        }
      },
    },
  )

  return referralBonusOfferEligibility
}
